// Classic › game page (#1119). A sentence with a highlighted part (the date,
// "Live updates on") takes that part as a parameter, so translators see the
// whole sentence; the view swaps an element in where it lands.
import { select } from '../../../plural'

const en = {
  backToSchedule: 'Back to Schedule',
  /** Beside the status pills while a refresh is in flight. */
  updating: 'Updating...',
  /** The live clock's accessible name. */
  clockLabel: (clock: string, period: string) => `Clock ${clock} period ${period}`,
  /** The centre of the hero once the game is over. */
  final: 'FINAL',
  /** The centre of the hero for a live game with live updates off. */
  versus: 'VS',
  stream: {
    live: 'Live Stream',
    replay: 'Watch Replay',
    chat: 'Live Chat',
  },
  /** The Scorebook entry button. */
  watchLive: 'Watch Live',
  liveBanner: {
    onLead: 'Live updates on',
    /** `lead` is onLead, shown highlighted. */
    on: (lead: string) => `${lead} — scores refresh in real time.`,
    offTitle: 'Scores not updating live',
    offBody: 'This game is in progress but live updates are off. Refresh for the latest score.',
  },
  comparison: {
    title: 'Team Comparison',
    leader: 'Leader',
  },
  boxScore: {
    /** The scrolling table's accessible name. */
    region: 'Box score',
    /** The player column, and a player's line when they have no position. */
    player: 'Player',
  },
  /** A scheduled game; `date` is shown highlighted. */
  checkBack: (sport: string, date: string) =>
    select(sport, {
      soccer: `Check back on ${date} to watch the match and see live stats.`,
      other: `Check back on ${date} to watch the game and see live stats.`,
    }),
  viewProfile: 'View Full Player Profile',
}

export default en
